/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ speed: NonNullable<unknown> }} Fleet_Motion_RunningInputs */

const vi_fleet_motion_running = /** @type {(inputs: Fleet_Motion_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang chạy ${i?.speed} km/h`)
};

/**

* @param {Fleet_Motion_RunningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_motion_running = /** @type {((inputs: Fleet_Motion_RunningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Motion_RunningInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_motion_running(inputs)
});